import api from '../api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Seller Orders API functions
export const sellerOrderApi = {
  // Get all orders for seller
  getSellerOrders: async (token, startDate = null, endDate = null) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      
      const response = await api.get('/orders/seller', {
        headers: getAuthHeaders(token),
        params: params
      });
      return response.data;
    } catch (error) {
      console.error('Error getting seller orders:', error);
      throw error;
    }
  },

  // Update order cost
  updateOrderCost: async (token, orderId, cost) => {
    try {
      const response = await api.put(`/orders/${orderId}/cost`, { cost }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating order cost:', error);
      throw error;
    }
  },

  // Get design case status for a specific order
  getOrderDesignCaseStatus: async (token, orderId) => {
    try {
      const response = await api.get(`/design-cases/order/${orderId}`, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting order design case status:', error);
      throw error;
    }
  },

  // Design Case API functions
  // Tạo design case mới
  createDesignCase: async (token, caseData) => {
    try {
      const response = await api.post('/design-cases', caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error creating design case:', error);
      throw error;
    }
  },
};

export default sellerOrderApi; 
